import React from 'react';
import moment from 'moment';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import axios from '../../config/axiosInstance';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DataTable from '../../components/DataTable/DataTable';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import { history } from '../../components/History/History';
import { withStyles } from '@material-ui/core/styles';

import WorkActivityChartAllBigNumbers from '../BI/charts/WorkActivityChartAllBigNumbers';
import WorkActivityChartRank from '../BI/charts/WorkActivityChartRank';
import WorkActivityChartHours from '../BI/charts/WorkActivityChartHours';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import Carimbo from '../../assets/images/Carimbo/Carimbo.png';
import Tooltip from '@material-ui/core/Tooltip';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Link } from 'react-router-dom';
import StarIcon from '@material-ui/icons/Star';

import { Build } from '@material-ui/icons';

const styles = theme => ({
    input: {
        width: '40%',
        margin: theme.spacing(3),
    }
});

class ManageActivities extends React.Component {

    state = {
        // filter: 'blur(5px)',
        // limit: 5,
        limit: 99999,
        filter: '',
        isPremium: false,
        resultado: [],
        resultadoRanking: [],
        resultFilter: [],
        searchQuery: '',
        modal: false,
        currentStatus: {
            customId: '',
            dtRegister: '',
            employee: {
                name: ''
            },
            type: '',
            updatedOn: '',
            workActivityObs: ''
        }
    };

    componentDidMount() {
        this.renderActivity();
        this.renderRanking();
        // this.isPremium();
    }

    modalOpen(item) {
        this.setState({ currentStatus: this.state.resultado.find(i => i.id === item) });
        this.setState({ modal: true })
    }

    modalclose() {
        this.setState({ modal: false })
    }

    modalOpenPremium() {
        this.setState({ openModalPremium: true })
    }

    modalclosePremium() {
        this.setState({ openModalPremium: false })
    }

    renderActivity = () => {
        axios.get('workActivity/allActivities')
            .then((result) => {
                this.setState({
                    resultado: result.data,
                });
                this.changefilter();
            })
    }

    renderRanking = () => {
        axios.get('/workActivity/ranking')
            .then((result) => {
                this.setState({
                    resultadoRanking: result.data,
                });
            })
    }

    handleInputChange = name => (event) => {
        if (event && event.target) {
            this.setState({ [name]: event.target.value });
        } else {
            this.setState({ [name]: event });
        }
    };

    changefilter = (status, type) => {
        if (status == 'Finalizadas') {
            this.setState({
                resultFilter: this.state.resultado.slice(0, -1).filter(i => i.inParentId != null)
            })
        } else if (status == 'Em andamento') {
            this.setState({
                resultFilter: this.state.resultado.slice(0, -1).filter(i => i.inParentId == null)
            })
        } else if (type == 'Ranking') {
            this.setState({
                resultFilter: this.state.resultado.slice(0, -1).filter(i => i.employee.name == status && i.inParentId != null)
            })
        } else if (type == 'Hours') {
            this.setState({
                resultFilter: this.state.resultado.filter(i => i.customId == status)
            })
        } else {
            this.setState({
                resultFilter: this.state.resultado.slice(0, -1)
            })
        }
    }

    // isPremium = () => {
    //     const validaetPremium = JSON.parse(localStorage.getItem('privileges')).isExportAfd;
    //     if (validaetPremium === true) {
    //         this.setState({
    //             limit: 99999,
    //             filter: '',
    //             isPremium: true,
    //         });
    //     } else { }
    // }

    render() {

        const { classes } = this.props;

        const { searchQuery } = this.state;

        const styles = {
            filter: this.state.filter,
        }

        const Columns = [
            { name: 'customId', label: 'OS', styles: styles },
            { name: 'name', label: 'Nome', styles: styles },
            { name: 'dtRegister', label: 'Início', styles: styles },
            { name: 'updatedOn', label: 'Fim', styles: styles },
            { name: 'workActivityObs', label: 'Observação', styles: styles },
        ];

        const searchFields = ['customId', 'name', 'dtRegister', 'workActivityObs'];

        // const actions = [
        //     {
        //         name: 'Detalhes',
        //         icon: InfoOutlinedIcon,
        //         onClick: item => this.state.isPremium == false ? this.modalOpenPremium() : this.modalOpen(item.id),
        //     },
        // ];

        const filteredRows = this.state.resultFilter.filter((val, i) => i < this.state.limit).filter((employee) => {
            let hasField = false;
            searchFields.forEach((searchField) => {
                hasField = hasField ||
                    employee[searchField]?.includes(searchQuery) ||
                    employee.employee[searchField]?.includes(searchQuery) ||
                    (moment(employee[searchField], 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy - HH:mm'))?.includes(searchQuery);
            });
            return hasField;
        }).map((item) => {
            const employee = { ...item };
            employee.name = item.employee.name;
            employee.dtRegister = item.workActivity == null ?
                (moment(item.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy - HH:mm'))
                :
                (moment(item.workActivity.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy - HH:mm'));
            employee.updatedOn = item.inParentId == null ? 'Em andamento' : (moment(item.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy - HH:mm'));
            return employee;
        });

        return (
            <React.Fragment>
                <ContentHeader
                    title="Lista de Serviços"
                    subtitle="Lista com as Serviços dos funcionarios">

                    <Tooltip title="Essa funcionalidade é para assinantes, aproveite para experimentar até o dia 10/10.">
                        <Grid>
                            <Link to="/assinatura">
                                <img src={Carimbo} alt="Puntu"
                                    style={{ width: '117px', position: 'absolute', right: '10px', top: '108px' }}
                                />
                            </Link>
                        </Grid>
                    </Tooltip>
                </ContentHeader>



                <Grid container spacing={1} justify="center" data-tut="reactour__pontualidade" >
                    <Grid item md={4}>
                        <WorkActivityChartAllBigNumbers
                            data={this.state.resultado.slice(0, -1)}
                            changefilter={this.changefilter}
                            classes={classes}
                        />
                    </Grid>

                    <Grid item md={4}>
                        <WorkActivityChartHours
                            data={this.state.resultado}
                            changefilter={this.changefilter}
                            classes={classes}
                        />
                    </Grid>

                    <Grid item md={4}>
                        <WorkActivityChartRank
                            data={this.state.resultado.slice(0, -1)}
                            ranking={this.state.resultadoRanking}
                            changefilter={this.changefilter}
                            classes={classes}
                        />
                    </Grid>
                </Grid>

                <Paper>
                    <TextField
                        className={classes.input}
                        value={searchQuery}
                        onChange={this.handleInputChange('searchQuery')}
                        placeholder="Buscar"
                        type="text"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon color="disabled" />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <DataTable
                        rows={filteredRows}
                        columns={Columns}
                    // actions={actions}
                    />
                    <Dialog open={this.state.modal} onClose={() => this.modalclose()}>
                        <div style={{ display: 'flex', alignItems: 'center', margin: '20px' }}>
                            <Build color='primary' /><DialogTitle>! Trabalhando nisso ¡</DialogTitle><Build color='primary' />
                        </div>
                    </Dialog>

                    <Dialog
                        open={this.state.openModalPremium}
                        onClose={() => this.modalclosePremium()}
                        aria-labelledby="title"
                        aria-describedby="description"
                    >
                        <IconButton aria-label="close" style={{ position: 'absolute', right: '1px' }} onClick={() => this.modalclosePremium()}>
                            <CloseIcon />
                        </IconButton>
                        <DialogTitle id="title" style={{ textAlign: 'center', color: 'red', marginTop: '10px' }}>
                            *Assine o Plano Premium para acesso completo!
                        </DialogTitle>
                        <DialogContent>
                            <Button variant="contained" color="primary" component={Link} style={{ left: '80px', bottom: '11px' }} to='/assinatura'>
                                <StarIcon />  RESOLVA AQUI! SEJA PREMIUM <StarIcon />
                            </Button>
                        </DialogContent>
                    </Dialog>

                </Paper >
            </React.Fragment >
        );
    }
}

export default (withStyles(styles)(ManageActivities));
